var _excluded = ["variant", "children", "dot", "count", "dotProps", "countProps"],
    _excluded2 = ["dotProps", "countProps"],
    _excluded3 = ["dotProps", "countProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { styled, useVariantProps } from '@pyt/core/native';
import React, { useMemo } from 'react';
import { Text } from '../text';
var Wrapper = styled('View', {
  position: 'relative'
}, 'badge');
var Dot = styled('View', {
  position: 'absolute',
  top: 0,
  right: 0,
  borderRadius: '100%',
  transform: [{
    translateX: '50%'
  }, {
    translateY: '-50%'
  }]
}, 'badge.dot');
var Count = styled(Text, {
  position: 'absolute',
  top: 0,
  right: 0,
  transform: [{
    translateX: '50%'
  }, {
    translateY: '-50%'
  }]
}, 'badge.count');
export var Badge = _ref => {
  var {
    variant = 'default',
    children,
    dot,
    count,
    dotProps: propDotProps,
    countProps: propCountProps
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var variantProps = useVariantProps(variant, 'badge');
  console.log(variantProps);

  var _useMemo = useMemo(() => {
    var {
      dotProps,
      countProps
    } = variantProps,
        restVariantProps = _objectWithoutProperties(variantProps, _excluded3);

    return _objectSpread({
      dotProps: _objectSpread(_objectSpread({}, dotProps), propDotProps),
      countProps: _objectSpread(_objectSpread({}, countProps), propCountProps)
    }, _objectSpread(_objectSpread({}, restVariantProps), props));
  }, [variantProps]),
      {
    dotProps,
    countProps
  } = _useMemo,
      restProps = _objectWithoutProperties(_useMemo, _excluded2);

  return React.createElement(Wrapper, restProps, children, count !== undefined ? React.createElement(Count, countProps, count) : React.createElement(Dot, dotProps));
};